// src/features/streams/useExtPlatAuth.ts

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { EXTPLAT_QUERY_KEYS } from '@/lib/constants/extplat';
import { ExtPlatApi } from '@/shared/api/ExtPlatApi';
import type { IExtPlatAuthView } from '@/lib/types/Simulcast';

interface UseExtPlatAuthsOptions {
  enabled?: boolean;
}

/** Fetch all ExtPlatAuth records for the current customer. */
export function useExtPlatAuths(options?: UseExtPlatAuthsOptions) {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: EXTPLAT_QUERY_KEYS.extPlatAuths(selectedCId ?? 0),
    queryFn: async () => {
      const res = await ExtPlatApi.getExtPlatAuths(selectedCId!);
      return res.data;
    },
    enabled: (options?.enabled ?? true) && selectedCId != null,
    staleTime: 5 * 60 * 1000,
  });
}

/** Build a lookup map from extPlatAuthId → IExtPlatAuthView. */
export function buildAuthMap(auths?: IExtPlatAuthView[]): Map<number, IExtPlatAuthView> {
  const map = new Map<number, IExtPlatAuthView>();
  if (auths) {
    for (const auth of auths) {
      map.set(auth.extPlatAuthId, auth);
    }
  }
  return map;
}
